import allComponentsDefinitionsMap from '../../dist/originalSchemas/componentsDefinitionsMap.json'
import allFullyRestrictedNonInflatedSchemas from '../../dist/allFullyRestrictedNonInflatedSchemas.json'
import restrictionMapSchemas from '../../dist/allRestrictionMapSchemas.json'
import * as schemaArrangement from '../schemaArrangement'

const restrictionMap = schemaArrangement.arrangeByDataTypeAndConvertSchemaNamesToOldStyleFileNames(
    restrictionMapSchemas,
    false
)
const restrictedNonInflatedSchemas = schemaArrangement.arrangeByDataTypeAndConvertSchemaNamesToOldStyleFileNames(
    allFullyRestrictedNonInflatedSchemas,
    true
)

export default {
    allComponentsDefinitionsMap,
    componentsDefinitionsMap: allComponentsDefinitionsMap,
    restrictedNonInflatedSchemas,
    restrictionMap
}
